<template>
  <b-card title="Execute SQL command">
    <b-row>
      <b-col>
        <b-form-group label="SQL">
          <b-textarea v-model="query" rows="10"></b-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-checkbox
          v-model="all"
          :value="true"
          :unchecked-value="false"
        > Run on all databases
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-btn variant="success" @click="run()">Run query</b-btn>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: "SQLConsole",
  data() {
    return {
      all: false,
      query: ""
    }
  },
  methods: {
    run() {
      this.$store.commit('loading')
      this.$store.dispatch("sql", { all: this.all, query: this.query }).then( () => {
        this.$store.commit('stopLoading')
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/SQL/Index.vue